import { GlamboxRequestHandler } from 'core/glambox/GlamboxRequestHandler';

/**
 * core/glambox/GlamboxApi
 * ----------------------------------------------------------------------
 * Expõe funções utilitárias para execução de requests HTTP de forma
 * simplificada, utilizando `GlamboxRequestHandler`.
 *
 * A ideia é simplificar e evitar a necessidade de configuração em favor de
 * uma convenção.
 *
 * @since     0.0.1
 */

/**
 * Instância do handler de requests, usa variáveis de ambiente para definir
 * qual URL será utilizada no request.
 *
 * @type {GlamboxRequestHandler}
 */
const ApiRequestHandler = new GlamboxRequestHandler();

/**
 * Handler de erro básico.
 *
 * NÃO ESTAMOS USANDO, LA LA LA LA 😗🎶.
 *
 * @param {Error} error
 *     Objeto de erro
 * @param {function} callback
 *     Callback para execução, recebe como primeiro parâmetro o retorno de
 *     API e, caso exista um, o objeto de erro
 * @param {*} resultObject
 *     Retorno de API, normalmente é um objeto
 */
const RequestErrorHandler = (error, callback, resultObject = null) => {
  if (callback) callback(resultObject);
  console.error(error);
};

/**
 * Executa requests na API da Glambox utilizando o modelo de endpoints.
 *
 * @param {object} endpoint
 *     Objeto de endpoint, contendo o caminho da URL, métodos permitidos e
 *     parâmetros obrigatórios para envio
 * @param {object} body
 *     Objeto com o corpo do request
 * @param {string} method
 *     Verbo HTTP utilizado para o request
 * @param {object} headers
 *     Opcional, objeto contendo pares chave/valor contendo os cabeçalhos do request
 * @param {object} urlParams
 *     Opcional, objeto contendo pares chave/valor contendo parâmetros de URL
 * @param {function} callback
 *     Opcional, callback a ser executado com a resposta do request, recebe apenas
 *     um parâmetro, que deve ser o corpo ou o erro
 * @returns {Promise<*>|null}
 */
export const ExecuteRequest = async (
  endpoint,
  body,
  method,
  headers = null,
  urlParams = null,
  callback = null
) => {
  ApiRequestHandler.addHeader('Content-Type', 'application/json');

  // ApiRequestHandler.addHeader(
  //   "Access-Control-Allow-Origin",
  //   "*"
  // );
  try {
    let response = await ApiRequestHandler.request(
      endpoint,
      body,
      method,
      headers,
      urlParams
    );

    let { data, status: statusCode } = response;

    if (callback && typeof callback === 'function') {
      callback({
        result: data.result !== undefined ? data.result : data,
        statusCode,
      });

      return null;
    }

    return {
      result: data.result ? data.result : data,
      statusCode,
    };
  } catch (e) {
    let statusCode = null,
      data;

    statusCode = e.response && e.response.status ? e.response.status : 403;

    data = e.response && e.response.data ? e.response.data : null;

    if (callback && typeof callback === 'function') {
      callback({
        result: data !== null && data.result !== undefined ? data.result : data,
        statusCode,
      });

      return null;
    }

    return {
      result: data.result ? data.result : data,
      statusCode,
    };
  }
};

/**
 * Executa um request em uma URL qualquer, da mesma forma que `ExecuteRequest`.
 *
 * @param {string} url
 *     URL para execução do request
 * @param {object} body
 *     Objeto com o corpo do request
 * @param {string} method
 *     Verbo HTTP utilizado para o request
 * @param {object} headers
 *     Opcional, objeto contendo pares chave/valor contendo os cabeçalhos do request
 * @param {string[]} required
 *     Opcional, array contendo os nomes dos campos obrigatórios para envio
 * @param {function} callback
 *     Opcional, callback a ser executado com a resposta do request, recebe apenas
 *     um parâmetro, que deve ser o corpo ou o erro
 * @returns {Promise<*>|null}
 */
export const ExecuteRequestOnUrl = async (
  url,
  body,
  method,
  headers = null,
  required = null,
  callback = null
) => {
  let response = await ApiRequestHandler.requestUrl(
    url,
    body,
    method,
    headers,
    required
  );

  let { data, status: statusCode } = response;

  if (callback && typeof callback === 'function') {
    callback({ result: data, statusCode });

    return null;
  }

  return { result: data, statusCode };
};
